import { useQuery } from '@tanstack/react-query'

import { getCardTransactionEvidenceRecords } from '@src/api'
import { DefaultApiGetCardTransactionEvidenceRecordsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCardTransactionEvidenceRecords = (
  params: DefaultApiGetCardTransactionEvidenceRecordsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled:
      !!params.organizationId &&
      !!params.paymentReferenceId &&
      !!params.cardTransactionEvidenceId,
    queryFn: () => getCardTransactionEvidenceRecords(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CARD_TRANSACTION_EVIDENCE_RECORDS,
      params.organizationId,
      params.paymentReferenceId,
      params.cardTransactionEvidenceId,
    ],
  })
}
